'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dCredentials$002dPage$0024 from "./presto.-List-Credentials-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002461 from "./presto.-Presto-Router$$anon$61.js";
import * as $j_presto$002etypes$0024$002dCredential$002dHash$0024 from "./presto.types$-Credential-Hash$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$60() {
  this.bkY = null;
  this.bkQ = null;
  this.bkR = false;
  this.bkZ = null;
  this.bl0 = false;
  this.bl3 = null;
  this.bkW = null;
  this.bkX = false;
  this.bkS = null;
  this.bkT = false;
  this.bkU = null;
  this.bkV = false;
  this.bl1 = false;
  this.bl2 = false;
  this.bkY = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bl3 = "ListCredentialsPage";
}
export { $c_Lpresto_PrestoRouter$$anon$60 as $c_Lpresto_PrestoRouter$$anon$60 };
$p = $c_Lpresto_PrestoRouter$$anon$60.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$60;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$60() {
}
export { $h_Lpresto_PrestoRouter$$anon$60 as $h_Lpresto_PrestoRouter$$anon$60 };
$h_Lpresto_PrestoRouter$$anon$60.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bkY;
});
$p.L = (function() {
  if ((!this.bkR)) {
    this.bkQ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bkR = true;
  }
  return this.bkQ;
});
$p.O = (function() {
  if ((!this.bl0)) {
    this.bkZ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bl0 = true;
  }
  return this.bkZ;
});
$p.E = (function() {
  return this.bl3;
});
$p.t = (function() {
  if ((!this.bkX)) {
    this.bkW = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hash", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bkX = true;
  }
  return this.bkW;
});
$p.M = (function() {
  if ((!this.bkT)) {
    this.bkS = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_presto$002etypes$0024$002dCredential$002dHash$0024.$m_Lpresto_types$CredentialHash$().ep())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bkT = true;
  }
  return this.bkS;
});
$p.Q = (function() {
  if ((!this.bkV)) {
    this.bkU = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002461.$c_Lpresto_PrestoRouter$$anon$61();
    this.bkV = true;
  }
  return this.bkU;
});
$p.w = (function() {
  if ((!this.bl2)) {
    this.bl1 = false;
    this.bl2 = true;
  }
  return this.bl1;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee447) => ((p) => \u03b4scrutinee447.cG5(p)))($j_presto$002e$002dList$002dCredentials$002dPage$0024.$m_Lpresto_ListCredentialsPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$60 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$60, "presto.PrestoRouter$$anon$60", ({
  Os: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$60 as $d_Lpresto_PrestoRouter$$anon$60 };
//# sourceMappingURL=presto.-Presto-Router$$anon$60.js.map
